import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { ServiceCode } from '@common/enums';
import { useFrontendSettings } from './useFrontendSettings';

export function useProcessStartWizardWithCards(): boolean {
    const { frontendSettings } = useFrontendSettings();
    const serviceConsumers = useSelector((state: IReduxState) => state.serviceConsumers.data.serviceConsumers);
    const serviceProviders = useSelector((state: IReduxState) => state.serviceProviders.data.serviceProviders);
    const isGeneralPractitioner = useSelector((state: IReduxState) => state.authentication.isGeneralPractitioner);
    const organizationHasGeneralPractitionerOrSupervisor = useSelector(
        (state: IReduxState) => state.authentication.organizationHasGeneralPractitionerOrSupervisor
    );

    if (frontendSettings.newProcessStartWizardEnabled === true) {
        return organizationHasGeneralPractitionerOrSupervisor;
    }

    return (
        serviceConsumers.some((item) => isGeneralPractitioner && hasRightsForService(item)) ||
        serviceProviders.some((item) => isAutoCreatedRight(item))
    );
}

function isAutoCreatedRight(right: { isAutoCreated: boolean; setToRequestedRightDateTime: string | Date | null }) {
    return right.isAutoCreated || right.setToRequestedRightDateTime !== null;
}

function hasRightsForService(right: { service: { code?: ServiceCode } }) {
    return right.service.code ? [ServiceCode.DermaCsc].includes(right.service.code) : false;
}
